import {Dispatch, SetStateAction, useEffect, useRef, useState} from 'react';

interface WithClickOpenProps {
	children:
		| React.ReactNode
		| ((params: {
				open: boolean;
				setOpen: Dispatch<SetStateAction<boolean>>;
				innerRef: React.RefObject<any>;
		  }) => React.ReactNode);
}

export const WithClickOpen = ({children}: WithClickOpenProps) => {
	const [open, setOpen] = useState(false);
	const innerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!innerRef) {
			return;
		}

		function handleClickOutside(event: Event) {
			if (innerRef.current && !innerRef.current.contains(event.target as Node)) {
				setOpen(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [innerRef]);

	return typeof children === 'function' ? children({open, setOpen, innerRef}) : children;
};
